// src/services/inventoryService.js
import api from "./api";

// Helper para formatear errores de Axios (útil para toasts)
const formatAxiosError = (error, defaultMessage) => {
  const status = error?.response?.status;

  const backendMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.response?.data?.msg;

  const baseMessage =
    backendMessage ||
    error?.message ||
    defaultMessage ||
    "Error en la petición";

  const finalMessage = status ? `${baseMessage} (HTTP ${status})` : baseMessage;

  return new Error(finalMessage);
};

export const inventoryService = {
  // ✅ Productos
  getProducts: async () => {
    try {
      const response = await api.get("/inventory");
      console.log("✅ inventoryService - Productos obtenidos:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ inventoryService - Error obteniendo productos:", {
        url: error?.config?.url,
        method: error?.config?.method,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });

      // ❌ Quitamos fallback /products: tu backend real es /inventory
      throw formatAxiosError(error, "Error al cargar productos");
    }
  },

  // ✅ Producto por ID
  getProductById: async (id) => {
    try {
      const response = await api.get(`/inventory/${id}`);
      return response.data;
    } catch (error) {
      console.error("❌ inventoryService - Error obteniendo producto por ID:", {
        id,
        url: error?.config?.url,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
      throw formatAxiosError(error, "Error al cargar el producto");
    }
  },

  // ✅ Crear
  createProduct: async (productData) => {
    try {
      const response = await api.post("/inventory", productData);
      console.log("✅ inventoryService - Producto creado:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ inventoryService - Error creando producto:", {
        url: error?.config?.url,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
      throw formatAxiosError(error, "Error al crear producto");
    }
  },

  // ✅ Update
  updateProduct: async (id, updates) => {
    try {
      const response = await api.put(`/inventory/${id}`, updates);
      console.log("✅ inventoryService - Producto actualizado:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ inventoryService - Error actualizando producto:", {
        id,
        url: error?.config?.url,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
      throw formatAxiosError(error, "Error al actualizar producto");
    }
  },

  // ✅ Delete
  deleteProduct: async (id) => {
    try {
      console.log("🔄 inventoryService: Enviando DELETE para producto ID:", id);
      const response = await api.delete(`/inventory/${id}`);
      console.log("✅ inventoryService: Respuesta DELETE exitosa:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ inventoryService: Error en deleteProduct:", {
        id,
        url: error?.config?.url,
        method: error?.config?.method,
        status: error?.response?.status,
        statusText: error?.response?.statusText,
        data: error?.response?.data,
        message: error?.message,
      });

      throw formatAxiosError(error, "Error al eliminar producto");
    }
  },

  // ✅ Analytics (si 404, no rompe UI)
  getDashboardAnalytics: async () => {
    try {
      const response = await api.get("/inventory/analytics/dashboard");
      console.log("✅ inventoryService - Analytics obtenidos:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ inventoryService - Error obteniendo analytics:", {
        url: error?.config?.url,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });

      if (error?.response?.status === 404) return null;

      throw formatAxiosError(error, "Error al cargar analytics");
    }
  },
};
